import api from "../api";

/**
 * Set the permissions of a user based on their userId.
 *
 * @param {string} user_id - The ID of the user.
 * @param {Array<Object>} permissions - The permissions to be set for the user.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const setPermission = async (user_id, permissions,role) => {
  const requestData = {
    user_id: user_id,
    permissions: permissions,
    role:role,
  };
  const endpoint =
    process.env.REACT_APP_API_ENDPOINT + "/api/user/setPermission";

  try {
    const response = await api.post(endpoint, requestData);
    return response.data;
  } catch (error) {
    console.error("Error setting user permissions:", error);
    throw error;
  }
};

export default setPermission;
